export default __webpack_public_path__ + "static/media/invoice.ba8fa463.svg";